import React from "react";
import { Alert, Form } from "react-bootstrap";

const EmailCell = ({ email, setEmail, emailError, setEmailError }) => {
  const handleEmail = (email) => {
    setEmail(email);
    setEmailError("");
    // Regular expression to check email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
    }
  };

  return (
    <Form.Group id="email">
      <Form.Control
        type="email"
        placeholder="Type Email"
        value={email}
        onChange={(e) => handleEmail(e.target.value)}
        isInvalid={!!emailError}
        isValid={email}
      ></Form.Control>
      {emailError && (
        <Alert variant="danger" className="mt-2">
          {emailError}
        </Alert>
      )}
    </Form.Group>
  );
};

export default EmailCell;
